var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container text-center" },
    [
      _c("h1", { staticClass: "center" }, [_vm._v("Auswertung")]),
      _vm._v(" "),
      [
        _vm._l(_vm.groupdQuestions, function (item, index) {
          return _c(
            "b-card",
            { key: item.id, staticClass: "mb-4", attrs: { "no-body": "" } },
            [
              _c(
                "b-card-header",
                {
                  staticClass: "card-header",
                  attrs: { "header-tag": "header" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row justify-content-between" },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.groupdQuestions[index].nameLeft)),
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v("vs.")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.groupdQuestions[index].nameRight)),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-card-body", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "col col-centered" },
                    [
                      _c("vue-slider", {
                        attrs: {
                          value: _vm.calcAvgCatResult(index),
                          tooltip: "none",
                          marks: _vm.marks1,
                          process: false,
                          "dot-style": { backgroundColor: "#36abff" },
                          disabled: true,
                          dotSize: 20,
                          id: `slider-input'${index}`,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-2" }),
              ]),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c(
          "b-card",
          { staticClass: "mb-4", attrs: { "no-body": "" } },
          [
            _c(
              "b-card-header",
              { staticClass: "card-header", attrs: { "header-tag": "header" } },
              [
                _c(
                  "div",
                  { staticClass: "d-flex flex-row justify-content-between" },
                  [_c("div", [_vm._v("Job-Empfehlung")])]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-card-body", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row mt-2 text-left" }, [
                _c("div", { staticStyle: { "white-space": "pre-wrap" } }, [
                  _vm._v(_vm._s(_vm.gptAnswer)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-2" }),
            ]),
          ],
          1
        ),
      ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("br"),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "btn btn-outline-primary",
              attrs: { to: "/signedin" },
            },
            [_vm._v("Zurück")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }